import { createContext, useContext } from 'react'

const context = createContext(false)

function useIsBot() {
	return useContext(context) ?? false
}

export { useIsBot }
